<script setup>
import FormSuggestion from "./FormSuggestion.vue";
import SuggestionServices from "@/api/services/suggestion.service";
import { useUiStore } from "@/app/stores/uiStore";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";


const uiStore = useUiStore();
const route = useRoute();
const suggestion = ref(null);

onMounted(() => {
  uiStore.startLoading();
  getSuggestion()
})

const getSuggestion = async () => {

  const id = route.params.id;
  await SuggestionServices.getSuggestion(id)
    .then((resp) => {
      suggestion.value = resp.data;
      uiStore.stopLoading();
      //this.suggestions = resp.data['hydra:member'];
    })





}
</script>

<template>
  <div v-if="!uiStore.loading && suggestion">
    <FormSuggestion :update="true" :suggestion="suggestion" />
  </div>
</template>
